var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"resultado-da-busca"}},[_c('h2',[_vm._v("Resultado")])])
}]

export { render, staticRenderFns }